import React from 'react';

import { Account, AccountPostData } from '../MyLom/Account/EditAccount/Types';

import { convertStringToBirthDay } from '../Api/Util';
import { isTestAccount } from '../Api/Account/Utils';

declare global {
    interface Window {
        __GGAccountData: {
            data: AccountPostData;
        };
    }
}

const accountDataFromDom = window.__GGAccountData ? readAccountDataFromJson(window.__GGAccountData.data) : null;
export const isLoggedIn =
    accountDataFromDom !== null && accountDataFromDom.hasOwnProperty('id') && typeof accountDataFromDom.id === 'string';
export const isTestUser = (isLoggedIn && accountDataFromDom && isTestAccount(accountDataFromDom.id)) || false;

export function loggedInCustomerId(): string | undefined {
    return accountDataFromDom?.id;
}

function readAccountDataFromJson(json: AccountPostData): Account {
    return {
        ...json,
        birthDate: json.birthDate ? convertStringToBirthDay(json.birthDate) : { year: '', month: '01', day: '01' },
    };
}

export const translateIdToName = (id: string): { name: string } => {
    if (!accountDataFromDom) {
        throw new Error('can not translate id to name without account data');
    }

    if (accountDataFromDom.id === id) {
        return {
            name: accountDataFromDom.firstName + ' ' + accountDataFromDom.lastName,
        };
    }

    // check profiles
    const profile = accountDataFromDom.profiles.find((prof) => prof.id === id);

    if (profile) {
        return {
            name: profile.profileName,
        };
    } else {
        return {
            name: '',
        };
    }
};

export const AccountContext = React.createContext<{
    accountData: Account | null;
    setAccountData: React.Dispatch<React.SetStateAction<Account | null>>;
    translateIdToName: (id: string) => { name: string };
    isLoggedIn: boolean;
    isTestUser: boolean;
}>({
    accountData: accountDataFromDom,
    setAccountData: () => {},
    translateIdToName,
    isLoggedIn,
    isTestUser,
});

export const AccountContextValueProvider: React.FunctionComponent = (props) => {
    const [accountData, setAccountData] = React.useState<Account | null>(accountDataFromDom);

    if (!accountData) {
        return <>{props.children}</>;
    }

    return (
        <AccountContext.Provider value={{ accountData, setAccountData, translateIdToName, isLoggedIn, isTestUser }}>
            {props.children}{' '}
        </AccountContext.Provider>
    );
};
